import React, { useEffect, useState } from 'react';
import { Card, Typography, Row, Col, Layout, Collapse, Spin, Alert, Button, Modal, } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, FolderOutlined, FolderOpenOutlined } from '@ant-design/icons';
import ProyectoService from '../../services/estructuracion/get_proyecto_id';
import { fetchPoaData } from '../../services/poa/get_poa';
import Header160 from '../header/header';
import FileManagerPOA from '../Poa/FileManagerPOA';
import ProyectEstructurado from '../ProyectoEstructurado/HomePage';
import './proyecto_estructuracion.css';

const { Title } = Typography;


const ProyectoView = ({ codigo_tarea }) => {
  const { oid } = useParams();
  const [proyecto, setProyecto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [itemParams, setItemParams] = useState(false);
  const [openModalVisitasEcas, setOpenModalVisitasEcas] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [poaPremilinar, setPoaPremilinar] = useState(false);

  useEffect(() => {
    const fetchProyectoData = async () => {
      try {
        const data = await ProyectoService.fetchProyectoByOid(oid);
        setProyecto(data);
      } catch (err) {
        console.error('Error al obtener los datos del proyecto:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (oid) fetchProyectoData();
  }, [oid]);

  const procesarMpoa = async (Mpoa, paso, proyecto, rutaEstructuracion) => {
    if (!Mpoa) {
      setOpenModalVisitasEcas(false);
      return;
    }

    if (Mpoa === '2.2.1') return null;

    const manejarActividadEspecial = (actividad) => {
      switch (actividad) {
        case '2.2.1.1':
        case '2.2.1.2':
        case '2.2.1.3':
          return '2.2.1';
        default:
          return actividad;
      }
    };

    const actividadBase = manejarActividadEspecial(Mpoa);

    try {
      const dataCompleta = await fetchPoaData();
      const dataPoa = dataCompleta.dataPoa;

      const findNodePath = (node, path = []) => {
        path.push(node);
        if (
          node.codigo_tarea === actividadBase &&
          !['2.2.1.2', '2.2.1.3'].includes(Mpoa)
        ) {
          return path;
        }
        if (['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
          if (node.children && node.children.length > 0) {
            for (let child of node.children) {
              if (Mpoa === '2.2.1.2' && child.key === 'indicador_33') {
                path.push(child);
                return path;
              }
              if (Mpoa === '2.2.1.3' && child.key === 'indicador_34') {
                path.push(child);
                return path;
              }
            }
          }
        }

        if (node.children && node.children.length > 0) {
          for (let child of node.children) {
            const result = findNodePath(child, [...path]);
            if (result) return result;
          }
        }
        return null;
      };

      let matchedPath = null;
      for (let nodo of dataPoa) {
        matchedPath = findNodePath(nodo);
        if (matchedPath) break;
      }

      if (matchedPath) {
        const initialData = extractData(matchedPath);
        const actividadData = initialData[0].actividadData;
        const tareaEncontrada = actividadData.find((item) => {
          if (['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
            return (
              item.codigo_tarea === actividadBase &&
              ((Mpoa === '2.2.1.2' && item.key === 'indicador_33') ||
                (Mpoa === '2.2.1.3' && item.key === 'indicador_34'))
            );
          }
          return item.codigo_tarea === actividadBase;
        });
        if (tareaEncontrada) {
          tareaEncontrada.rutaEstructuracion = rutaEstructuracion;
          tareaEncontrada.proyecto = proyecto;
          tareaEncontrada.paso = paso;
          setOpenModalVisitasEcas(true);
          setItemParams(tareaEncontrada);
        } else {
          setOpenModalVisitasEcas(false);
          setItemParams(null);
        }
      } else {
        console.warn('No se encontró ningún nodo coincidente');
      }
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  const extractData = (children) =>
    children.flatMap((child) => {
      if (child.children && child.tipo === 'Actividad') {
        const actividadData = child.children.flatMap((grandchild) => {
          if (grandchild.children && grandchild.tipo === 'Tarea') {
            return grandchild.children.flatMap((greatGrandchild) => {
              if (greatGrandchild.tipo === 'Indicador') {
                const fecha = greatGrandchild.meta_e?.[0]?.fecha;
                const fechaFormateada = fecha
                  ? new Date(fecha).toLocaleDateString('es-ES')
                  : '-';
                const medioV = greatGrandchild.medioVerificacion || null;
                return {
                  key: greatGrandchild.key,
                  codigo_tarea: grandchild.codigo_tarea,
                  codActividad: grandchild.codActividad,
                  nameActividad: child.actividad,
                  tarea: grandchild.tarea,
                  indicador: greatGrandchild.title,
                  medioV,
                  fechas: fechaFormateada,
                  responsables: 'N/A',
                  soportes: 'N/A',
                  datoIndicador: greatGrandchild,
                };
              }
              return [];
            });
          }
          return [];
        });
        return [
          {
            actividadTitle: child.title,
            actividad: child.actividad,
            actividadData,
          },
        ];
      }
      return [];
    });



  const handleCardClick = () => navigate(`/es_proyectos`);

  const construirRuta = (indicador, proyecto, nombreRuta) => {
    if (!indicador || !proyecto) return "";

    const indicadorId = indicador?.codigo_indicador;
    const medioVId = indicador?.MedioV?.[0]?.codigo_mv;

    const proyectoCodigo = proyecto?.codigo;
    const proyectoNombre = proyecto?.nombre_proyecto;


    return `indicador_${indicadorId}/medio_verificacion_${medioVId}/${proyectoCodigo}. ${proyectoNombre}/${nombreRuta}`;
  };


  const handleFolderClick = (tarea, paso, indicador, proyecto) => {
    if (tarea.codigo === '1.3.5' || tarea.codigo === '1.3.7') {
      const actividadOid = proyecto?.actividades?.[0]?.codigo ?? null;
      const tareaOid = tarea?.codigo?.replace(/\./g, '') ?? null;
      const indicadorOid = indicador.codigo_indicador ?? null;
      const medioVerificacionOid = indicador?.MedioV?.[0]?.codigo_mv ?? null;
      setSelectedRecord({
        actividad: actividadOid,
        tarea: tareaOid,
        indicador: indicadorOid,
        tarea_codigo: tarea.codigo,
        medioVerificacion: medioVerificacionOid,
        paso,
        proyecto,
        rutaFiltrar: `${proyecto.codigo}/${paso.nombre_ruta}`,
      });
      setPoaPremilinar(true);
    } else {
      const rutaEstructuracion = construirRuta(indicador, proyecto, paso.nombre_ruta);
      procesarMpoa(tarea.codigo, paso.nombre_ruta, proyecto, rutaEstructuracion);
    }
  };


  const hideModalVisitasEcas = () => {
    setOpenModalVisitasEcas(false);
    setItemParams(null);
  };

  const hideModal1 = () => {
    setSelectedRecord(null);
    setPoaPremilinar(false);
  };

  if (loading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );

  if (error)
    return (
      <div style={{ padding: '20px' }}>
        <Alert message="Error al cargar el proyecto" type="error" />
      </div>
    );

  if (!proyecto)
    return (
      <div style={{ padding: '20px' }}>
        <Alert message="No se encontró el proyecto" type="warning" />
      </div>
    );

  // 🔹 NUEVA forma de Collapse
  const collapseItems =
    proyecto.actividades?.[0]?.tareas.map((tarea, tareaIndex) => ({
      key: `tarea-${tareaIndex}`,
      label: (
        <span
          style={{
            color: "#FFFFFF",            // 🔹 Color del texto
            display: "block",
          }}
        >
          {tarea.codigo} - {tarea.nombre_tarea}
        </span>
      ),
      children: (
        <Row gutter={24} justify="center" className="custom-background-estructuracion">
          {tarea.indicadores.map((indicador, indicadorIndex) => (
            <React.Fragment key={`indicador-${indicadorIndex}`}>
              <Row gutter={16} justify="space-around" align="top">
                {indicador.rutas.map((ruta, rutaIndex) => (
                  <Col key={`ruta-${rutaIndex}`} className="custom-col">
                    <div className="custom-card-container">
                      <Card

                        hoverable
                        style={{
                          width: '310px',
                          borderRadius: '16px',
                          overflow: 'hidden',
                          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                          border: 'none',
                          transition: 'all 0.3s ease',
                        }}
                        styles={{
                          body: {
                            padding: '0',
                          },
                        }}
                      >
                        <div
                          style={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #287AB1 100%)',
                            padding: '20px',
                            position: 'relative',
                          }}
                        >


                          <div
                            style={{
                              width: '56px',
                              height: '56px',
                              borderRadius: '14px',
                              background: 'rgba(255,255,255,0.15)',
                              backdropFilter: 'blur(10px)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginBottom: '16px',
                            }}
                          >
                            <FolderOutlined style={{ fontSize: '28px', color: '#fff' }} />
                          </div>

                          <div
                            style={{
                              fontSize: '17px',
                              fontWeight: 600,
                              color: '#fff',
                              marginBottom: '6px',
                              lineHeight: 1.3,
                              position: 'absolute',
                              top: '45%',
                              left: '90px',
                              transform: 'translateY(-50%)',
                            }}
                          >
                            {ruta.nombre_ruta}
                          </div>

                          <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', position: 'absolute', top: '80px', left: '20px' }}>
                            Carpeta de documentos
                          </div>
                        </div>

                        {/* Body con estadísticas */}
                        <div style={{ padding: '20px' }}>
                          {/* Stats row */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginBottom: '20px',
                              padding: '14px',
                              background: '#f8fafc',
                              borderRadius: '10px',
                            }}
                          >
                            <div style={{ textAlign: 'center', flex: 1 }}>
                              <div style={{ fontSize: '18px', fontWeight: 700, color: '#287AB1' }}>
                                {ruta.soportes?.filter(s => ['pdf', 'doc', 'docx'].includes(s.extension?.toLowerCase()?.replace('.', ''))).length || 0}
                              </div>
                              <div style={{ fontSize: '11px', color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.5px', padding: '0 10px' }}>
                                Documentos
                              </div>
                            </div>
                            <div style={{ width: '1px', background: '#e8e8e8' }} />
                            <div style={{ textAlign: 'center', flex: 1 }}>
                              <div style={{ fontSize: '18px', fontWeight: 700, color: '#52c41a' }}>
                                {ruta.soportes?.filter(s => ['xls', 'xlsx'].includes(s.extension?.toLowerCase()?.replace('.', ''))).length || 0}
                              </div>
                              <div style={{ fontSize: '11px', color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Excel
                              </div>
                            </div>
                          </div>

                          {/* Botón de acción */}
                          <Button
                            type="primary"
                            icon={<FolderOpenOutlined />}
                            onClick={() => handleFolderClick(tarea, ruta, indicador, proyecto)}
                            style={{
                              width: '100%',
                              height: '44px',
                              borderRadius: '10px',
                              fontWeight: 600,
                              fontSize: '14px',
                              background: 'linear-gradient(135deg, #287AB1 0%, #1e3a5f 100%)',
                              border: 'none',
                              boxShadow: '0 4px 12px rgba(40, 122, 177, 0.3)',
                            }}
                          >
                            Gestionar archivos
                          </Button>
                        </div>
                      </Card>
                    </div>
                  </Col>
                ))}
              </Row>
            </React.Fragment>
          ))}
        </Row>
      ),
    })) || [];


  return (
    <Layout className="container">
      <div className="header-filter-container d-flex align-items-center justify-content-between">
        <Header160 />
        <div className="container elemtos">
          <div className="input-group-container">
            <div>
              <Button onClick={handleCardClick} style={{ width: 125 }} icon={<ArrowLeftOutlined />}>
                Regresar
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: '20px', overflowY: 'auto' }}>
        <Title level={3} className="gradient-text">
          {proyecto.codigo} - {proyecto.nombre_proyecto}
        </Title>
        <Title level={5} className="justified-title">
          {proyecto.actividades?.[0]?.codigo}{' '}
          {proyecto.actividades?.[0]?.nombre_actividad || 'Nombre de la Actividad'}
        </Title>

        {/* 🔹 Collapse actualizado */}
        <Collapse accordion items={collapseItems} style={{ background: "#287AB1" }} />

      </div>

      {/* 🔹 Modales actualizados */}
      <Modal
        title={<span className="custom-modal-title">Medios de verificación</span>}
        open={openModalVisitasEcas}
        onCancel={hideModalVisitasEcas}
        footer={null}
        destroyOnHidden
        width="95%"
        style={{ top: 20 }}
      >
        <FileManagerPOA codigo_tarea={{ codigo_tarea: itemParams }} onClose={hideModalVisitasEcas} />
      </Modal>

      <Modal
        title={<span className="custom-modal-title">Proyectos Estructurados</span>}
        open={poaPremilinar}
        onCancel={hideModal1}
        footer={null}
        destroyOnHidden={true}
        width="95%"
        style={{ top: 20 }}
      >
        <ProyectEstructurado codigo_tarea={itemParams} filtro={selectedRecord} />
      </Modal>
    </Layout>
  );
};

export default ProyectoView;
